import { useEventListener } from '@vueuse/core';

const swapImageSources = () => {
    const images: NodeListOf<HTMLImageElement> = document.querySelectorAll('.theme-switch-image');

    images.forEach((image) => {
        const currentSrc = image.src;
        const newSrc = image.dataset.theme_switch_src;

        image.setAttribute('src', newSrc);
        image.setAttribute('data-theme_switch_src', currentSrc);
    });
};

const imageChangeLogic = () => {
    const themeSwitcher: HTMLElement = document.querySelector('#theme-switcher');

    if (themeSwitcher) {
        useEventListener(themeSwitcher, 'click', swapImageSources);
    }
};

useEventListener(document, 'DOMContentLoaded', imageChangeLogic);
